// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--DOGGs","image":"_103a151b99--image--fpH8B","text":"_103a151b99--text--na9Fm"};